<div class="p-d-flex p-dir-col log-in-layout">
  <sigv-login-header></sigv-login-header>
  <main class="log-in-bg p-d-flex p-flex-column p-jc-center" [style.background-image]="'url(' + blobUrlBg +  ')'">
    <div class="log-in-area p-d-flex p-flex-row">
      <div class="log-in-desc p-flex-column p-ai-center" [style.background-image]="'url(' + blobUrlLogin + ')'">
        <img src="./assets/images/header-logo-holding.svg" alt="" />
      </div>
      <div class="log-in-input">
        <form
          class="log-in-form"
          (submit)="(loginForm.valid)"
          #loginForm="ngForm"
          novalidate
          style="width: 100%"
        >
          <div class="log-in-ele-container log-in-title">
            <p>{{ "Login.Title" | translate }}</p>
          </div>
          <div class="log-in-ele-container p-d-flex p-flex-column">
            <label for="account">{{ "Login.Account" | translate }}</label>
            <div class="p-d-flex p-dir-col p-jc-start log-in-input-container">
              <img
                class="log-in-icon"
                src="./assets/images/ic-account.svg"
                width="24px"
                height="24px"
              />
              <input
                id="account"
                name="account"
                type="text"
                class="login-input-ac"
                autocomplete="off"
                [placeholder]="'Login.Account' | translate"
                pInputText
                [(ngModel)]="loginFormModel.account"
                [required]="true"
                #accountDom="ngModel"
              />
            </div>
            <!-- <small
              class="p-error"
              *ngIf="
                accountDom.invalid &&
                (accountDom.dirty || accountDom.touched) &&
                accountDom.errors?.required
              "
            >
              {{
                "Common.Validate.MustNotBeBlank"
                  | translate: { fieldName: "Login.Account" | translate }
              }}
            </small> -->
          </div>
          <div class="log-in-ele-container p-d-flex p-flex-column">
            <label for="password">{{ "Login.Password" | translate }}</label>
            <div class="p-d-flex p-dir-col p-jc-start log-in-input-container">
              <img
                class="log-in-icon"
                src="./assets/images/ic-password.svg"
                width="24px"
                height="24px"
              />
              <input
                id="userPassword"
                name="userPassword"
                type="password"
                class="login-input-pw"
                autocomplete="off"
                [placeholder]="'Login.Password' | translate"
                pInputText
                [(ngModel)]="loginFormModel.password"
                [required]="true"
                #passwordDom="ngModel"
              />
            </div>
            <!-- <small
              class="p-error"
              *ngIf="
                passwordDom.invalid &&
                (passwordDom.dirty || passwordDom.touched) &&
                passwordDom.errors?.required
              "
            >
              {{
                "Common.Validate.Required"
                  | translate: { fieldName: "Login.Password" | translate }
              }}
            </small> -->
          </div>

          <div *ngIf="elementControlJSON.Login.GoogleReCaptcha.display" class="log-in-ele-container p-d-flex p-flex-column p-ai-center">
            <re-captcha
              name="captcha"
              (error)="errored($event)"
              errorMode="handled"
              [(ngModel)]="loginFormModel.recaptchaToken"
              required
              [siteKey]="appConfig.recaptchaSiteKey"
            ></re-captcha>
          </div>
          <div class="log-in-ele-container button">
            <div class="button">
              <a
                role="button"
                class="btn btn-login"
                [class.disable]="!loginForm.form.valid"
                (click)="submit()"
                >{{ "Common.Button.SignIn" | translate }}</a
              >
            </div>
          </div>
          <div
            *ngIf="loginFormModel?.account"
            class="log-in-ele-container log-in-fp-mb p-d-flex p-flex-row p-jc-around"
          >
            <a
              href="javascript:void(0)"
              class="log-in-fp"
              (click)="forgetPassword()"
              >{{ "Login.ForgetPassword" | translate }} ?</a
            >
          </div>
        </form>
      </div>
    </div>
  </main>
  <div class="login-container" *ngIf="false">
    <form
      class="login-form"
      (submit)="loginForm.valid && submit()"
      #loginForm="ngForm"
      novalidate
    >
      <div class="p-d-flex p-jc-center">
        <div class="login-form-logo"></div>
      </div>
      <div class="login-form-body">
        <div class="p-fluid">
          <div class="p-field p-my-0">
            <label for="account">{{ "Login.Email" | translate }}</label>
            <input
              id="account"
              name="account"
              type="text"
              autocomplete="off"
              [placeholder]="'Login.Email' | translate"
              pInputText
              [(ngModel)]="loginFormModel.account"
              [required]="true"
              [email]="true"
              #userEmailDom="ngModel"
            />
          </div>
        </div>
      </div>
      <div class="p-text-center mb-20">
        <button
          pButton
          type="submit"
          [label]="'Common.Button.SignIn' | translate"
          class="p-content-button"
          [disabled]="!loginForm.form.valid"
        ></button>
      </div>
    </form>
  </div>
  <app-footer></app-footer>
</div>
<p-toast position="top-right" class="cfc-toast"></p-toast>
<!-- 聯徵資訊 -->
<p-dialog [header]="'Login.ForgetPassword' | translate" [(visible)]="isShowForgetPasswordDialog"
  [modal]="true" [draggable]="false" closeIcon="pi pi-close" styleClass="p-dialog-sm" appendTo="body">
  <div class="p-d-flex">
    <div class="p-field-radiobutton p-mr-5" *ngIf="otpShowEmail">
      <p-radioButton value="Email" name="type" [(ngModel)]="otpType"
        ></p-radioButton>
      <label for="type1">
        {{ "ForgotPassword.Email" | translate }}
      </label>
    </div>
    <div class="p-field-radiobutton" *ngIf="otpShowPhone">
      <p-radioButton value="SMS" name="type" [(ngModel)]="otpType"
        ></p-radioButton>
      <label for="type2">
        {{ "ForgotPassword.PhoneNo" | translate }}
      </label>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-grid p-jc-center">
      <button pButton class="p-button-primary p-content-button p-mr-2 p-button p-component"
        [label]="'Common.Button.Ok' | translate" (click)="forgetPasswordByOTP()"></button>
    </div>
  </ng-template>
</p-dialog>